/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {defineMessages, FormattedMessage, injectIntl} from 'react-intl';
import { showModalPortfolio, hideModalPortfolio } from '../../../actions/modal';
import withStyles from "isomorphic-style-loader/lib/withStyles";
import s from "../../../style/page.css";
import f from '../../../style/foundation.min.css';
import portfolio from './Portfolio.css';
import sv from '../../../js/vendor/swiper.min.css';
import jfp from '../../../js/vendor/jquery.fullpage.min.css';
import icon from '../../../fonts/ionicons.min.css';
import slide from "./components/Modal/Slide.css";

// MODAL DIALOG
import { LgScreenHidden , LgScreen } from 'react-responsive-redux';
import Mobile from './Mobile/Mobile';
import Desktop from './Desktop/Desktop';
import Close from '../../../components/Button/Button-close/Button-close';
import LazyLoad from 'react-lazy-load';
import { modalPortfolio, modalPortfolioSlide, modalZ, gridAnimation } from './components/Scripts/init';


const messages = defineMessages({
    portfolioTitle: {
        id: 'portfolio.portfolioTitle',
        defaultMessage: 'What did'
    },
    portfolioTitleBr: {
        id: 'portfolio.portfolioTitleBr',
        defaultMessage: 'we do'
    }
});


class BflBlock extends React.Component {
    render() {
        return (
            <li>
                <div className={slide.slide + " " + ['slide']}>
                    {this.props.isOpen && (
                        <img key={this.props.alt} src={this.props.imgURL} alt={this.props.alt}/>
                    )}
                </div>
            </li>
        )
    }
}
class MnogoshinBlock extends Component {
    render() {
        return (
            <li>
                <div className={slide.slide + " " + ['slide']}>
                    {this.props.isOpen && (
                        <img key={this.props.alt} src={this.props.imgURL} alt={this.props.alt}/>
                    )}
                </div>
            </li>
        );
    }
}
class CircusfestBlock extends Component {
    render() {
        return (
            <li>
                <div className={slide.slide + " " + ['slide']}>
                    {this.props.isOpen && (
                        <img key={this.props.alt} src={this.props.imgURL} alt={this.props.alt}/>
                    )}
                </div>
            </li>
        );
    }
}
class SalondecorBlock extends Component {
    render() {
        return (
            <li>
                <div className={slide.slide + " " + ['slide']}>
                    {this.props.isOpen && (
                        <img key={this.props.alt} src={this.props.imgURL} alt={this.props.alt}/>
                    )}
                </div>
            </li>
        );
    }
}
class VobuhoveBlock extends Component {
    render() {
        return (
            <li>
                <div className={slide.slide + " " + ['slide']}>
                    {this.props.isOpen && (
                        <img key={this.props.alt} src={this.props.imgURL} alt={this.props.alt}/>
                    )}
                </div>
            </li>
        );
    }
}
class AcademicstomBlock extends Component {
    render() {
        return (
            <li>
                <div className={slide.slide + " " + ['slide']}>
                    {this.props.isOpen && (
                        <img key={this.props.alt} src={this.props.imgURL} alt={this.props.alt}/>
                    )}
                </div>
            </li>
        );
    }
}
class SpectrpravaBlock extends Component {
    render() {
        return (
            <li>
                <div className={slide.slide + " " + ['slide']}>
                    {this.props.isOpen && (
                        <img key={this.props.alt} src={this.props.imgURL} alt={this.props.alt}/>
                    )}
                </div>
            </li>
        );
    }
}
class StickerBlock extends Component {
    render() {
        return (
            <li>
                <div className={slide.slide + " " + ['slide']}>
                    {this.props.isOpen && (
                        <img key={this.props.alt} src={this.props.imgURL} alt={this.props.alt}/>
                    )}
                </div>
            </li>
        );
    }
}
class VeronikapolishchukBlock extends Component {
    render() {
        return (
            <li>
                <div className={slide.slide + " " + ['slide']}>
                    {this.props.isOpen && (
                        <img key={this.props.alt} src={this.props.imgURL} alt={this.props.alt}/>
                    )}
                </div>
            </li>
        );
    }
}
class YurKonsBlock extends Component {
    render() {
        return (
            <li>
                <div className={slide.slide + " " + ['slide']}>
                    {this.props.isOpen && (
                        <img key={this.props.alt} src={this.props.imgURL} alt={this.props.alt}/>
                    )}
                </div>
            </li>
        );
    }
}
class TtsumyBlock extends Component {
    render() {
        return (
            <li>
                <div className={slide.slide + " " + ['slide']}>
                    {this.props.isOpen && (
                        <img key={this.props.alt} src={this.props.imgURL} alt={this.props.alt}/>
                    )}
                </div>
            </li>
        );
    }
}
class OkClubBlock extends Component {
    render() {
        return (
            <li>
                <div className={slide.slide + " " + ['slide']}>
                    {this.props.isOpen && (
                        <img key={this.props.alt} src={this.props.imgURL} alt={this.props.alt}/>
                    )}
                </div>
            </li>
        );
    }
}
class MyvoyagesBlock extends Component {
    render() {
        return (
            <li>
                <div className={slide.slide + " " + ['slide']}>
                    {this.props.isOpen && (
                        <img key={this.props.alt} src={this.props.imgURL} alt={this.props.alt}/>
                    )}
                </div>
            </li>
        );
    }
}

class Portfolio extends Component {
    constructor (props) {
        super(props);
        this.state = {
            countList: '',
            activeTab: 0,
            data: this.props.PORTFOLIO,
            isOpenBfl: false,
            isOpenMnogoshin: false,
            isOpenCircusfest: false,
            isOpenSalondecor: false,
            isOpenVobuhove: false,
            isOpenAcademicstom: false,
            isOpenSpectrprava: false,
            isOpenSticker: false,
            isOpenVeronikapolishchuk: false,
            isOpenYurKons: false,
            isOpenTtsumy: false,
            isOpenOkClub: false,
            isOpenMyvoyages: false,
        };
        this.mouseOverRun = this.mouseOverRun.bind(this);
        this.changeTabOnClick = this.changeTabOnClick.bind(this);
    }
    componentWillMount(){
        let o = this.props.PORTFOLIO;
        let arr = [];
        for (var key in o) {arr.push(key)}
        this.setState({ countList: arr })
    }
    changeTabOnClick(index) {
        this.setState({
            activeTab: index
        });
        if ($(window).width() <= 1100) {
            if (this.props.modalIsActive)
                this.props.closeModal();
            else
                this.props.openModal();
        }
    }
    mouseOverRun = () => {
        setTimeout(function() {
            // if ($(window).width() >= 1100) {
            //     gridAnimation();
            //     modalPortfolio();
            //     modalZ();
            // }
            gridAnimation();
            modalPortfolio();
            modalZ();
            modalPortfolioSlide();
        }, 3000);
    };
    onOverlayClose(e){
        if(e.target.id === 'modal')
            this.props.closeModal();
    }
    handleClickBfl = e => {
        this.changeTabOnClick();
    };
    handleClickMnogoshin = e => {
        this.changeTabOnClick();
    };
    handleClickCircusfest = e => {
        this.changeTabOnClick();
    };
    handleClickSalondecor = e => {
        this.changeTabOnClick();
    };
    handleClickVobuhove = e => {
        this.changeTabOnClick();
    };
    handleClickAcademicstom = e => {
        this.changeTabOnClick();
    };
    handleClickSpectrprava = e => {
        this.changeTabOnClick();
    };
    handleClickSticker = e => {
        this.changeTabOnClick();
    };
    handleClickVeronikapolishchuk = e => {
        this.changeTabOnClick();
    };
    handleClickYurKons = e => {
        this.changeTabOnClick();
    };
    handleClickTtsumy = e => {
        this.changeTabOnClick();
    };
    handleClickOkClub = e => {
        this.changeTabOnClick();
    };
    handleClickMyvoyages = e => {
        this.changeTabOnClick();
    };
    render() {
        const that = this;
        let activeClass = this.props.activeId;
        let DATAPORTFOLIO = this.props.DATAPORTFOLIO;
        return (
            <div className={portfolio['blockPortfolio']}>
                <div className={['edgtf-parallax-holder'] + " " + s.marginBlock} data-parallax="{&quot;y&quot;: -100, &quot;smoothness&quot;: 20}">
                    <div className="edgtf-elements-holder   edgtf-one-column  edgtf-responsive-mode-768 ">
                        <div className="edgtf-eh-item" data-item-class="edgtf-eh-custom-8567" data-1024-1280="60px 0 148px 0">
                            <div className="edgtf-eh-item-inner">
                                <div className="edgtf-eh-item-content edgtf-eh-custom-8567">
                                    <div className={s.row}>
                                        <h2 className={portfolio.titleBlock}>{DATAPORTFOLIO.titleLeft}</h2>
                                        <h2 className={s.floatRightBorder}><FormattedMessage {...messages[DATAPORTFOLIO.title]} /><br /> <span><FormattedMessage {...messages[DATAPORTFOLIO.titleBr]} /></span></h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <section className={['content'] + " " + ['clearfix'] + " " + s.content + " " + s.clearfix}>

                    <div>
                        <LgScreen>
                            <Desktop />
                            <div>
                                <LazyLoad
                                    offsetVertical={0}
                                    onContentVisible={() => {
                                        this.mouseOverRun();
                                    }}
                                >
                                    <div id="portId" className={['container']}>
                                        <div className={['content']}>
                                            {this.state.countList.map(function(item, index) {
                                                return (
                                                    <div key={index} id={item.toLowerCase()} className={portfolio.dialog + " " + ['dialog']}>
                                                        <div className={portfolio['dialog__overlay'] + " " + ['dialog__overlay']}></div>
                                                        <div className={portfolio['dialog__content'] + " " + ['dialog__content']}>
                                                            <Close onClick={that.props.closeModal}/>
                                                            <div className={slide.container}>
                                                                <div id={"slide" + [item[0].toUpperCase() + item.toLowerCase().slice(1)]} className={slide.slideshow + " " + ['slideshow']}>
                                                                    <ul>
                                                                        {that.props.PORTFOLIO[item].map(function(item, index) {
                                                                            return (
                                                                                <li key={index}>
                                                                                    <div className={slide.slide + " " + ['slide']}>
                                                                                        <img key={item.alt} src={item.imgURL} alt={item.alt}/>
                                                                                    </div>
                                                                                </li>
                                                                            )
                                                                        })}
                                                                    </ul>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                </LazyLoad>
                            </div>
                        </LgScreen>
                    </div>
                    <div>
                        <LgScreenHidden>
                            <Mobile />
                            <div>
                                <LazyLoad
                                    offsetVertical={0}
                                    onContentVisible={() => {
                                        this.mouseOverRun();
                                    }}
                                >
                                    <div id="portId" className={['container']}>
                                        <div className={['content']}>
                                            {this.state.countList.map(function(item, index) {
                                                return (
                                                    <div key={index} id={item.toLowerCase()} className={portfolio.dialog + " " + ['dialog']}>
                                                        <div className={portfolio['dialog__overlay'] + " " + ['dialog__overlay']}></div>
                                                        <div className={portfolio['dialog__content'] + " " + ['dialog__content']}>
                                                            <Close onClick={that.props.closeModal}/>
                                                            <div className={slide.container}>
                                                                <div id={"slide" + [item[0].toUpperCase() + item.toLowerCase().slice(1)]} className={slide.slideshow + " " + ['slideshow']}>
                                                                    <ul>
                                                                        {that.props.PORTFOLIO[item].map(function(item, index) {
                                                                            return (
                                                                                <li key={index}>
                                                                                    <div className={slide.slide + " " + ['slide']}>
                                                                                        <img key={item.alt} src={item.imgURL} alt={item.alt}/>
                                                                                    </div>
                                                                                </li>
                                                                            )
                                                                        })}
                                                                    </ul>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                </LazyLoad>
                            </div>
                        </LgScreenHidden>
                    </div>
                </section>
            </div>
        );
    }
}


export default injectIntl(
    compose(
        withStyles(s, portfolio, slide, sv, jfp, f, icon),
        connect(
            state => ({
            PORTFOLIO: state.dataRu.PORTFOLIO,
            DATAPORTFOLIO: state.dataRu.DATAPORTFOLIO,
            modalIsActive: state.modalReducer.modalIsActive,
        }),
        dispatch => ({
            openModal: () =>{
        return dispatch(showModalPortfolio());
        },
            closeModal: () =>{
    return dispatch(hideModalPortfolio());
}
        })
)
)(Portfolio));
